import "../Css/Journy.css";
import Section from "./Section";
import aljazeeraImage from "../Images/Aljazeera.jpeg";
import markavipImage from "../Images/markavip-image.jpeg";
import schoolImage from "../Images/school.jpg";
import majestarImage from "../Images/majestar.jpeg";
import kasetdawwarImage from "../Images/kasetdawwar.jpeg";
import dotmediaImage from "../Images/dotmedia.jpg";
export default function Journey() {
  return (
    <div className="Journey-container" id="journey">
      <Section
        name="aljazeera-section"
        image={aljazeeraImage}
        header="الجزيرة"
        article="أول رحلتي كانت تدريبي في مكتب قناة الجزيرة في عمّان، الأسبوع الأول لم يكن سهلاً. لا أنسى أنني كنت أسلمهم أوراق الأخبار العاجلة والترجمات، وكانوا يلقونها في سلة المهملات دون قراءتها. الأسبوع الأول كان مليء بالدموع، لكنني أكملت، ومع الوقت صرت شخصاً مُلاحظاً وأستلم مهام حقيقية في المكتب، إلى درجة أن مغادرتي للمكتب في نهاية التدريب كانت مؤثرة واستلمتُ منهم هدية محفورة بعلامة الجزيرة تقديراً لجهودي. البدايات دائماً مليئة بالتحديات"
      />
      <Section
        name="reversed-section"
        image={markavipImage}
        header="ماركا في آي بي"
        article="عملت كمترجمة في شركة التجارة الإلكترونية  ماركا في اي بي, تجربة الترجمة دائماً ممتعة بالنسبة إلي استخدام اللغتين المحببتين إلى قلبي أمرٌ لا يُضاهى"
      />
      <Section
        name="school-section"
        image={schoolImage}
        header="مدرسة الحياة"
        article="أحبُ أن أذكر أنني عملت أسبوعين كمعلمة في مدرسة رياض أطفال. وهي تجربة جديرة بالذكر لسبب واحد. وهو أن يعرف الإنسان نقاط ضعفه سريعاً لكي يتخطاها سريعاً إلى المرحلة التي تتبعها"
      />
      <Section
        name="reversed-section"
        image={majestarImage}
        header="الماجستير"
        article="دراسة الماجستير هي الخطوة التي تشبه أحلامي تماماً. تجربة عملية تطبيقية تنفيذية لكل ما يخص الصحافة المكتوبة والمسموعة المرئية. أستاذة وزملاء من داخل الأردن وخارجه. فلسفة المعهد آتية من فلسفة أوروبية وإنما بنَفَس عربي أردني برعاية الأميرة ريم العلي. خضنا الواقع بنظرية الرجل الواحد من أجل كل المهام. كان تجربة مرهقة تماماً وممتعة تماماً في آنٍ معاً"
      />
      <Section
        name="covid"
        image={kasetdawwarImage}
        header="تدويناتي الصوتية"
        article="فترة الكورونا كانت مرحلتي الأولى في تجربة التسجيلات الصوتية. باستخدام استديو وإمكانيات منزلية، بدأتُ مشوار تسجيل تدويناتي القصيرة بصوتي. لطالما أحببت الاستديو الصوتي ولطالما حلمت بالعمل الإذاعي. وكانت هذه الخطوة هي تنفيسة شبيهة بخُرم إبرة لحلم واسع"
      />
      <Section
        name="reversed-section"
        image={dotmediaImage}
        header="دوت ميديا"
        article="دوت ميديا.. المكان الشامل للتسويق والمجتمعات التفاعلية والإنتاج الفني والإبداعي. لأول مرة أجرب فيها التحدث إلى الكاميرا بشوق وشغف. المحتوى الإبداعي والإعلامي هو ما يجعلني أستيقظ كل صباح لأطرحه بحماس في أقسام هذه المؤسسة المتشعبة الشبابية الروح والمحضر"
      />
    </div>
  );
}
